module.exports = __webpack_public_path__ + "static/img/introduce-item.8727d4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduce-item.jpg
// module id = Qr4o
// module chunks = 0